import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  CustomerDPCsvErroredAction,
  CustomerDPDeletedAction,
  CustomerDPDeleteErroredAction,
  CustomerDPErroredAction,
  CustomerDPsCsvLoadedAction,
  CustomerDPsLoadedAction,
  DeleteCustomerDPClickedAction,
  LoadCustomerDPsAction,
  LoadCustomerDPsCsvAction,
} from './admin-customer-dp.action';
import { AdminCustomerDPService } from './admin-customer-dp.service';
import { AdminCustomerDPApiError, AdminCustomerDPApiErrorTypes } from './admin-customer-dp.errors';
import { DownLoadFileService } from 'src/app/shared/services/download-file.service';
import { SnackBarEffectCreatorService } from 'src/app/shared/services/effect-creators/snackbar-effect-creator.service';

@Injectable()
export class AdminCustomerDPEffects {
  deleteCustomerDP$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeleteCustomerDPClickedAction),
      mergeMap(({ customerDPId }) =>
        this.adminCustomerDPService.deleteCustomerDPByIdForAdmin(customerDPId).pipe(
          map(() => CustomerDPDeletedAction()),
          catchError((err) =>
            of(
              CustomerDPDeleteErroredAction({
                error: new AdminCustomerDPApiError(
                  AdminCustomerDPApiErrorTypes.AdminDeleteCustomerDPError,
                  err.error.error,
                ),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  displayDPDeletedSuccessfullySnackbar$ = this.snackBarEffectCreator.createEffect({
    initiatingAction: CustomerDPDeletedAction,
    message: () => 'Customer DP deleted',
  });

  displayDPDeleteFailedSnackbar$ = this.snackBarEffectCreator.createEffect({
    initiatingAction: CustomerDPDeleteErroredAction,
    message: ({ error }) => `Customer DP deletion failed: ${error.error.message}`,
    persistent: true,
  });

  loadCustomerDPs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadCustomerDPsAction, CustomerDPDeletedAction),
      mergeMap(() =>
        this.adminCustomerDPService.getCustomerDPsForAdmin().pipe(
          map((customerDPs) => CustomerDPsLoadedAction({ customerDPs })),
          catchError((err) =>
            of(
              CustomerDPErroredAction({
                error: new AdminCustomerDPApiError(
                  AdminCustomerDPApiErrorTypes.AdminLoadCustomerDPsError,
                  err.error.error,
                ),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  loadCustomerDPsCsv$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadCustomerDPsCsvAction),
      mergeMap(() =>
        this.adminCustomerDPService.getCustomerDPsCsvForAdmin().pipe(
          map((customerDPsCsv) => {
            this.downloadFileService.blobToFile(
              customerDPsCsv,
              'application/octet-stream',
              `customer-dps-${new Date().toISOString()}.csv`,
            );
            return CustomerDPsCsvLoadedAction();
          }),
          catchError((err) =>
            of(
              CustomerDPCsvErroredAction({
                error: new AdminCustomerDPApiError(
                  AdminCustomerDPApiErrorTypes.AdminLoadCustomerDPsCsvError,
                  err.error.error,
                ),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private adminCustomerDPService: AdminCustomerDPService,
    private downloadFileService: DownLoadFileService,
    private snackBarEffectCreator: SnackBarEffectCreatorService,
  ) {}
}
